export const cSharpDefaultSource = `// Console.WriteLine() will be matched by pattern!
// click diff tab to see rewrite.

using System;

namespace MyApp
{
    public class Program
    {
        public static void Main(string[] args)
        {
            Console.WriteLine("Hello, World!");
            Console.Write("Debug message: ");
            Console.WriteLine($"User ID: {userId}");
            
            if (isDebugMode)
            {
                Console.WriteLine("Application started successfully");
                Console.Write("Processing...");
            }
            
            // This won't be matched
            var message = "Console.WriteLine(\\"not me\\")";
            SomeOtherClass.WriteLine("also not matched");
        }
        
        private static void ProcessData()
        {
            Console.WriteLine("Processing data");
            Console.Write("Progress: 50%");
        }
    }
}`;

export const cSharpDefaultCodemod = `import { type SgRoot } from "@ast-grep/napi";
import type CSharp from "@ast-grep/napi/lang/c_sharp";

async function transform(root: SgRoot<CSharp>): Promise<string> {
  const rootNode = root.root();

  const nodes = rootNode.findAll({
    rule: {
      any: [
        { pattern: "Console.WriteLine($ARG)" },
        { pattern: "Console.Write($ARG)" },
      ]
    },
  });

  const edits = nodes.map(node => {
    const arg = node.getMatch("ARG").text();
    return node.replace(\`Logger.Log(\${arg})\`);
  });

  const newSource = rootNode.commitEdits(edits);
  return newSource;
}

export default transform;
`;

export const cSharpDefaultConfig = `
# Codemod Studio uses ast-grep to match and rewrite code.
# https://ast-grep.github.io/guide/rule-config.html#rule
id: replace-console-calls
language: csharp
rule:
  any:
    - pattern: Console.WriteLine($ARG)
    - pattern: Console.Write($ARG)
fix:
  Logger.Log($ARG)
`.trim();
